<template>
  <div v-if="show" class="modal-overlay">
    <div class="modal-content">
      <h2>Möchten Sie sich wirklich abmelden?</h2>
      <div class="button-container">
        <button @click="confirmLogout" class="logout-button">JA</button>
        <button @click="$emit('close')" class="cancel-button">NEIN</button>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '@/services/apiService';

export default {
  name: 'LogoutConfirmationPage',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    mounted() {
      console.log('LogoutConfirmationPage mounted'); // Debug statement
    },

    async confirmLogout() {
      console.log('Confirm Logout called'); // Debug statement
      try {
        // Use the new auth system - just clear local data
        // No need to call backend logout endpoint since JWT is stateless
        apiService.clearAuthData();

        // Clear any additional legacy data
        localStorage.removeItem('userId');
        localStorage.removeItem('selectedLanguage');
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('username');
        localStorage.clear(); // Clear everything

        this.$emit('logout');
        this.$emit('close');
        this.$router.push('/login');
      } catch (error) {
        console.error('Error during logout:', error);
        localStorage.clear(); // Clear everything
        // Even if there's an error, clear data and redirect
        apiService.clearAuthData();
        this.$router.push('/login');
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: 90%;
  text-align: center;
}

h2 {
  margin-top: 0;
  color: #2c3e50;
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
}

.button-container {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;
}

.logout-button,
.cancel-button {
  padding: 0.75rem 2rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: opacity 0.2s;
}

.logout-button {
  background-color: #dc3545;
  color: white;
}

.cancel-button {
  background-color: #6c757d;
  color: white;
}

.logout-button:hover,
.cancel-button:hover {
  opacity: 0.9;
}
</style>